import React from "react";
import { Link } from "react-router-dom";
import "aos/dist/aos.css";
import "./Banner.css";
const Banner = () => {
  return (
    <div
      data-aos="fade-up"
      data-aos-duration="2000"
      className="lg:mt-28 bg-banner mb-52 lg:ml-20"
    >
      {/* <div className="blur-2xl bg-[#751FEE] rounded-lg w-1/12 h-20">
        </div> */}
      <div>
        <div>
          <p className="text-primary font-mono">Hi, my name is</p>
          <h1 className="lg:text-7xl md:text-5xl text-4xl text-secondary font-bold my-5 text">
            Ahsan Kabir
          </h1>
          <h1 className="lg:text-7xl md:text-6xl text-3xl lg:flex text-accent font-bold">
            I build things for the web.
            {/* <span className="text-secondary">
            <TypeWriterEffect
              startDelay={2000}
              cursorColor="#3F3D56"
              multiText={["Developer","Coder", "Designer"]}
              multiTextDelay={1000}
              typeSpeed={60}
              multiTextLoop
            />
          </span> */}
          </h1>
          <p className="my-9 text-accent text-lg">
            {" "}
            <br /> A Frontend focused{" "}
            <span className="text-primary ">Web Developer</span> building the
            Frontend of Websites <br /> and Web Applications that leads to the
            success of the overall product
          </p>

          <Link
            to="/"
            className=" btn btn-outline px-10 rounded-sm border border-primary  font-mono text-primary"
          >
            Resume
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Banner;
